import { FormikProvider, useFormik } from "formik";
import React from "react";
import { WizardContext } from "react-albus";

import { Forms, Grid } from "components";
import { banks, removeSpecialChars } from "utils";

import { Action } from "components";

import { bankSchema } from "../schema";
import { useSignup } from "../store";

const initialValues = {
  name: "",
  branch: "",
  account: "",
  digit: "",
  email: "",
};

export type BankValues = typeof initialValues;

export type BankProps = {
  wizard: WizardContext;
};

export const Bank = ({ wizard }: BankProps) => {
  const { setValues, getValues } = useSignup();

  const form = useFormik<BankValues>({
    initialValues: getValues("bank") || initialValues,
    validationSchema: bankSchema,
    onSubmit: (values) => {
      setValues("bank", values);
      wizard.next();
    },
  });

  const handleBanks = async (value: string) => {
    const list = banks.filter((bank) => {
      const name = removeSpecialChars(
        `${bank.id} - ${bank.name}`.toLowerCase()
      );
      const sentence = removeSpecialChars(value.toLowerCase());
      return name.includes(sentence);
    });

    return list.map(({ id, name }) => ({
      label: `${id} - ${name}`,
      value: `${id} - ${name}`,
    }));
  };

  return (
    <FormikProvider value={form}>
      <form onSubmit={form.handleSubmit}>
        <Grid gap={[".5rem", "1rem"]}>
          <Forms.Autocomplete
            name="name"
            label="Banco"
            placeholder="Busque pelo código ou nome"
            emptyMessage="Nenhum banco encontrado."
            onSearch={handleBanks}
          />

          <Forms.InputGroup
            name="branch"
            label="Agência"
            placeholder="Digite a agência"
          />
        </Grid>

        <Grid
          gap={[".5rem", "1rem"]}
          space={[".5rem", "1rem 0"]}
          columns={["auto", "1fr .5fr"]}
        >
          <Forms.InputGroup
            name="account"
            label="Número da conta (sem dígito)"
            placeholder="Digite o número da conta"
          />

          <Forms.InputGroup
            name="digit"
            label="Dígito da conta"
            placeholder="Digite o dígito da conta"
          />
        </Grid>

        <Grid gap={[".5rem", "1rem"]}>
          <Forms.InputGroup
            name="email"
            label="E-mail operacional"
            placeholder="Digite o e-mail operacional"
            tip="E-mail para envio de faturas/boletos."
          />
        </Grid>

        <Action
          back={{
            handler: wizard.previous,
          }}
          next="Notas de esclarecimento"
        />
      </form>
    </FormikProvider>
  );
};
